import {
    Flex, Layout,
} from 'antd';
import { CSSProperties } from 'react';
import { Outlet } from 'react-router-dom';

const layoutStyle: CSSProperties = {
    minHeight: '100vh',
};

export const ErrorPageLayout = () => {
    return (
        <Layout style={layoutStyle}>
            <Layout.Content>
                <Flex vertical align="center" justify="center" style={layoutStyle}>
                    <Outlet />
                </Flex>
            </Layout.Content>
        </Layout>
    );
};
